import React from "react";
import { FiUser } from "react-icons/fi";
import { LiaUserCheckSolid } from "react-icons/lia";
import { LuBookMarked } from "react-icons/lu";
import { PiStudent } from "react-icons/pi";
import { TbUserHeart } from "react-icons/tb";

export default function InstituteInfo() {
  return (
    <section>
      <div className="mx-20 grid grid-cols-2 md:grid-cols-5 gap-10 text-center my-20">
        <div className="flex flex-col md:flex-row items-center  text-slate-500">
          <LuBookMarked className="text-5xl " />
          <div className="text-xl text-left ml-5">
            <p>মোট কোর্স</p>
            <p>৯ টি</p>
          </div>
        </div>
        <div className="flex flex-col md:flex-row items-center  text-slate-500">
          <LiaUserCheckSolid className="text-5xl " />
          <div className="text-xl text-left ml-5">
            <p>উস্তাদ/উস্তাদা</p>
            <p>৬ জন</p>
          </div>
        </div>
        <div className="flex flex-col md:flex-row items-center  text-slate-500">
          <TbUserHeart className="text-5xl " />
          <div className="text-xl text-left ml-5">
            <p>অ্যাডমিন</p>
            <p>১০ জন</p>
          </div>
        </div>
        <div className="flex flex-col md:flex-row items-center  text-slate-500">
          <FiUser className="text-5xl " />
          <div className="text-xl text-left ml-5">
            <p>বর্তমান স্টুডেন্ট</p>
            <p>৯৫৬ জন</p>
          </div>
        </div>
        <div className="flex flex-col md:flex-row items-center  text-slate-500">
          <PiStudent className="text-5xl " />
          <div className="text-xl text-left ml-5">
            <p>গ্রাজুয়েট স্টুডেন্ট</p>
            <p>৪০০০ জন</p>
          </div>
        </div>
      </div>
    </section>
  );
}
